import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-134c83b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "company-assessment-pulse-form"
}
const _hoisted_2 = { class: "pulse-title" }

import {
	type CompanyAssessmentAnswerDto,
	type CompanyAssessmentCategoryDto,
	type CompanyAssessmentQuestionAnswerDto,
	type CompanyAssessmentQuestionDto,
} from "@/dto";
import { computed, ref, watch } from "vue";
import type { PropType } from "vue";
import { cloneDeep } from "lodash";
import { i18n } from "@/i18n";
import CompanyAssessmentPulseQuestion from "./CompanyAssessmentPulseQuestion.vue";

type PulseAnswerDto = CompanyAssessmentAnswerDto & {
	pulseCategory: CompanyAssessmentCategoryDto | null;
};

type PulseQuestionRow = {
	question: CompanyAssessmentQuestionDto;
	answer: CompanyAssessmentQuestionAnswerDto;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyAssessmentPulseForm',
  props: {
	pulseAnswer: {
		type: Object as PropType<PulseAnswerDto | null>,
		default: null,
	},
},
  emits: ["update:pulse-answer"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localPulseAnswer = ref<PulseAnswerDto | null>(null);

watch(
	() => props.pulseAnswer,
	(newValue) => {
		localPulseAnswer.value = newValue ? cloneDeep(newValue) : null;
	},
	{ immediate: true, deep: true }
);

const language = computed(() => String(i18n.global.locale));

const pulseCategory = computed(() => localPulseAnswer.value?.pulseCategory ?? null);

const questions = computed<CompanyAssessmentQuestionDto[]>(() => {
	return [...(pulseCategory.value?.questions ?? [])].sort((a, b) => a.order - b.order);
});

const questionRows = computed<PulseQuestionRow[]>(() => {
	if (!localPulseAnswer.value) return [];

	const rows: PulseQuestionRow[] = [];
	for (const question of questions.value) {
		const answer = localPulseAnswer.value.questionAnswers.find(
			(questionAnswer) => questionAnswer.questionId === question.id
		);
		if (answer) rows.push({ question, answer });
	}

	return rows;
});

function updateQuestionAnswer(updatedAnswer: CompanyAssessmentQuestionAnswerDto) {
	const answer = localPulseAnswer.value?.questionAnswers.find(
		(questionAnswer) => questionAnswer.questionId === updatedAnswer.questionId
	);
	if (!answer || !localPulseAnswer.value) return;

	Object.assign(answer, updatedAnswer);
	emit("update:pulse-answer", localPulseAnswer.value);
}

return (_ctx: any,_cache: any) => {
  const _component_HakoContentBlock = _resolveComponent("HakoContentBlock")!

  return (questionRows.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_HakoContentBlock, {
          "no-header": true,
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("pulse.title")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionRows.value, (row, index) => {
              return (_openBlock(), _createBlock(CompanyAssessmentPulseQuestion, {
                key: row.question.id,
                question: row.question,
                "question-answer": row.answer,
                language: language.value,
                "is-odd": index % 2 === 1,
                "onUpdate:questionAnswer": updateQuestionAnswer
              }, null, 8, ["question", "question-answer", "language", "is-odd"]))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})